export default __webpack_public_path__ + "static/media/log_out_icon_outline.2a480a77.svg";